__turbopack_context__.v({
  "container": "DrawDaysSelector-module__p1PamW__container",
  "dayOptions": "DrawDaysSelector-module__p1PamW__dayOptions",
});
